import React from "react"
import { Link } from "react-router-dom"
import logoO from "../img/logo/logoO100.png" 
export default function SezioneProdotti({elemTitolo,elem1,elem2,elem3,elem4,link1,link2,link3,link4,classe,id}){

    function titolo(){
        if(elemTitolo ==="In Allestimento..."){
           return <span className="allestimento" >In Allestimento<span>.</span><span>.</span><span id="puntoAllestimento">.</span></span>
        }
        return elemTitolo
    }
    function elemento(ele){
        if(ele==="logo"){
            return <button><img src={logoO} alt="logo" /></button>
        }
        return <button>{ele}</button>
    }

    return (
        <div className={classe}>
                <div className="evidenzaTitolo">
                <h2>{titolo()}</h2>
                </div>
                
                <section className="sezione" id={id}>
                    <div className="centro">
                        <Link to={link1}>{elemento(elem1)}</Link>
                    </div>
                    <div className="centro">
                        <Link to={link2}>{elemento(elem2)}</Link>
                    </div>
                    <div className="centro">
                        <Link to={link3}>{elemento(elem3)}</Link>
                    </div>
                    <div className="centro">
                        <Link to={link4}>{elemento(elem4)}</Link>
                    </div>
                   
                </section>
        </div>
    )
}